export const getDialogPolyfill = () => {
  return new Promise( ( resolve ) => {
    import( 'dialog-polyfill' ).then( ( { default: { registerDialog } } ) => {
      resolve( registerDialog );
    } );
  } );
};